import React from "react";
import { withNavBars } from "../../HOCs";
import PublicListing from "./publicListing";

class PublicListingParent extends React.Component {
    render() {
        return <PublicListing {...this.props} />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(PublicListingParent, props);
